import React from 'react';
import Swal from 'sweetalert2';
import { domain } from '../../../../Urls/Services/Api_urls';
import { Restart } from 'iconoir-react';

export const ChangeOrder = (props) => {
    const groups = window.sessionStorage.getItem("groups");
    const token = window.sessionStorage.getItem("token");

    const tableMeta = props.tableMeta;
    const tipoStatus = [{ id: 1, name:"Por Firmar"}, { id: 2, name:"Recibida" }, { id: 3, name:"Firmado"}]

    const rechazar = async () => {
        Swal.fire({
            title: "Editar estado de la solicitud ",
            html: `
            <form>
                <div class="m-3">
                    <div class="mb-12">
                        <label for="NameLabelUpdate" class="labelFount">Estado</label>
                        <select class="Status" id="Status" style="width: 80%; height: 3.4rem; ">
                            <option key="" value="${tableMeta.is_actived}">${tableMeta.is_actived}</option>
                            ${tipoStatus.map(opcion => `<option key="${opcion.id}" value="${opcion.name}">${opcion.name}</option>`).join('')}
                        </select>
                    </div>
                </div>
            </form>
            `,
            focusConfirm: false,
            confirmButtonText: "Editar",
            didOpen: () => {
                const Status = document.getElementById('Status');
                console.log(Status);
            },
            preConfirm: () => {
                const selectedStatus = document.getElementById("Status").value;
                // Validación de acuerdo a tableMeta.package
                if (tableMeta.package === true && selectedStatus === 'Firmado') {
                    Swal.showValidationMessage('No puedes seleccionar "Firmado" cuando es empaquetamiento.');
                    return false; // Previene que se envíe la petición
                }

                if (tableMeta.package === false && selectedStatus === 'Recibida') {
                    Swal.showValidationMessage('No puedes seleccionar "Recibida" cuando no es empaquetamiento.');
                    return false; // Previene que se envíe la petición
                }

                const myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${token}`);
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    is_actived: document.getElementById("Status").value, // Toma el ID del campo oculto
                });

                const requestOptions = {
                    method: "PUT",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                };

                return fetch(
                    `${domain}/portal/${tableMeta.id}/update_state/`,
                    requestOptions
                )
                    .then((response) => response.json())
                    .then((result) => Swal.fire({
                        title: "Cambio de estado correcto",
                        text: result.msg,
                        icon: "success"
                    }))
                    .finally(() => window.location.reload())
                    .catch((error) => console.log("error", error));
            },
        });
    };

    const allowedStatus = new Set(["Orden creada", "Por Firmar"]);

    if (!allowedStatus.has(tableMeta.is_actived)) {
        return (
            <>
                <button
                    className='p-1 cursor-pointer bg-red-500 hover:bg-red-600 text-white rounded-md '
                    onClick={rechazar}
                    title="Cambiar estado"
                >
                    <Restart />
                </button>
            </>
        );
    } else return null;
}